export const environment = {
  apiBaseUrl: 'https://api.dev.earthon.ai/edrive',
  edriveLoginUrl: 'https://api.dev.earthon.ai/edrive/auth/login',
  edriveLogoutUrl: 'https://api.dev.earthon.ai/edrive/auth/logout',
};
